import React from "react";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../components/ui/tabs";
import { SignUpForm } from "../components/sign-up-form";
import { LoginForm } from "../components/login-form";
import AuthLayout from "../layouts/auth";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "../contexts/I18nProvider";

function GetStarted() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "signup";
  const { t } = useTranslation();

  return (
    <AuthLayout>
      <Tabs
        value={activeTab}
        onValueChange={(val) => setSearchParams(`tab=${val}`)}
        className="w-[400px] v"
      >
        <TabsList className="w-[400px] rounded-xl">
          <TabsTrigger
            value="signup"
            className="w-[50%] active:bg-primary rounded-xl font-bold text-base"
          >
            {t('auth.tabs.signUp')}
          </TabsTrigger>
          <TabsTrigger
            value="login"
            className="w-[50%] active:bg-primary rounded-xl font-bold text-base"
          >
            {t('auth.tabs.login')}
          </TabsTrigger>
        </TabsList>
        <TabsContent value="signup">
          <SignUpForm />
        </TabsContent>
        <TabsContent value="login">
          <LoginForm />
        </TabsContent>
      </Tabs>
    </AuthLayout>
  );
}

export default GetStarted;
